import {createApi} from "@reduxjs/toolkit/query/react"
import baseQuery from "../../utils/apiIIKOConfig"
import {IBasicParams, IBasicResponse} from "../../types/api"
import {
    IReviewCategoryTagCreateParams,
    IReviewCategoryTagCreateResponse,
    IReviewCategoryTagDeleteParams,
    IReviewCategoryTagGet,
    IReviewCategoryTagUpdateParams
} from "./ReviewCategoryTagApiTypes"

export const reviewCategoryTagApi = createApi({
    reducerPath: "reviewCategoryTagApi",
    baseQuery,
    tagTypes: ["review-category-tags"],
    endpoints: build => ({
        createReviewCategoryTags: build.mutation<IBasicResponse<IReviewCategoryTagCreateResponse>, IReviewCategoryTagCreateParams>({
            query: ({lang, name}) => ({
                method: "POST",
                url: `v1/review-category-tags`,
                headers: {
                    "Accept-Language": lang,
                },
                body: {name}
            }),
            invalidatesTags: ["review-category-tags"]
        }),
        getReviewCategoryTags: build.query<IBasicResponse<IReviewCategoryTagGet[]>, IBasicParams>({
            query: ({lang}) => ({
                method: "GET",
                url: `v1/review-category-tags/list`,
                headers: {
                    "Accept-Language": lang
                },
            }),
            providesTags: ["review-category-tags"]
        }),
        updateReviewCategoryTags: build.mutation<IBasicResponse<void>, IReviewCategoryTagUpdateParams>({
            query: ({lang, id, name}) => ({
                method: "PUT",
                url: `v1/review-category-tags/${id}`,
                headers: {
                    "Accept-Language": lang,
                },
                body: {name}
            }),
            invalidatesTags: ["review-category-tags"]
        }),
        removeReviewCategoryTags: build.mutation<IBasicResponse<void>, IReviewCategoryTagDeleteParams>({
            query: ({lang, id}) => ({
                method: "DELETE",
                url: `v1/review-category-tags/${id}`,
                headers: {
                    "Accept-Language": lang
                }
            }),
            invalidatesTags: ["review-category-tags"]
        }),
    })
})

export const {
    useCreateReviewCategoryTagsMutation,
    useGetReviewCategoryTagsQuery,
    useUpdateReviewCategoryTagsMutation,
    useRemoveReviewCategoryTagsMutation
} = reviewCategoryTagApi
